// O QUE ACONTECE COM UMA QUANTIDADE DE ADD-ON QUANDO A PESSOA PEDE OUTRA.
//
// ⚠️ A REGRA VIVE EM DOIS LUGARES, e é de propósito: aqui, com teste, e uma cópia dentro de
// `supabase/functions/asaas-update-subscription` (Deno não importa fora do diretório da
// function). Divergir faz a tela prometer uma coisa e o servidor fazer outra.
//
// A política de tempo está na migração 20260922150000, que criou as colunas `scheduled_extra_*`:
// aumentar libera na hora e entra na cobrança seguinte; reduzir espera o fim do ciclo que a
// pessoa já pagou. Por isso `extra_*` e `scheduled_extra_*` podem discordar, e por isso a
// pergunta "mudou?" não se responde olhando só para `extra_*`.

export interface QuantidadeDeAddon {
  /** `extra_*` na assinatura: o que está EM VIGOR e foi pago. */
  contratado: number;
  /** `scheduled_extra_*`: a redução que já foi pedida e ainda não virou. `null` se não há. */
  agendado: number | null;
  /** O que a pessoa está pedindo agora. */
  pedido: number;
}

/**
 * - `aumenta` — passa do contratado: vale na hora, cobra na próxima.
 * - `reduz`   — fica abaixo do contratado: agenda para a virada do ciclo.
 * - `desfaz`  — pede de volta exatamente o contratado, cancelando uma redução agendada.
 * - `igual`   — pede o que já está valendo; não há o que fazer.
 *
 * ⚠️ `desfaz` É O CASO QUE FALTAVA, e a falta dele era um beco sem saída. Sem separá-lo de
 * `igual`, quem agendava 2→1 perfis e se arrependia pedia 2 de volta e ouvia "Nada mudou no
 * plano" — porque o pedido era igual ao `contratado`. Não havia caminho nenhum para cancelar o
 * agendamento antes da virada do ciclo.
 */
export function decisaoDoAjuste({ contratado, agendado, pedido }: QuantidadeDeAddon):
  'aumenta' | 'reduz' | 'desfaz' | 'igual' {
  const vigente = agendado ?? contratado;
  if (pedido === vigente) return 'igual';
  if (pedido > contratado) return 'aumenta';
  if (pedido === contratado) return 'desfaz';
  return 'reduz';
}

/** Vale a pena mandar este ajuste ao servidor? Só se alguma das dimensões saiu do lugar. */
export function planoMudou(dimensoes: readonly QuantidadeDeAddon[]): boolean {
  return dimensoes.some((d) => decisaoDoAjuste(d) !== 'igual');
}
